export default __webpack_public_path__ + "static/media/plastic.ae136f44.svg";